export const styles = (theme) => ({
    root: {
        height: '100%',
        margin: theme.spacing(1.5),
        padding: theme.spacing(3),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%',
        },
        overflow: 'scroll',
    },
    history: {
        marginTop: theme.spacing(2.5),
    },
    grid: {
        padding: theme.spacing(2),
    },
    divider: {
        width: 'auto',
        height: '1px',
    },
    link: {
        textDecoration: 'none',
    },
    customToolbar: {
        marginLeft: 14,
        width: '900px',
    },
    tableTitle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        overflow: 'visible',
    },
    customTooltip: {
        marginLeft: -16,
        marginTop: '-2px',
    },
});

export const subComponents = (translations) => [
    { name: 'Mobile', path: '/mobile', permissions: null },
    { name: 'Remote', path: '/remote', permissions: null },
    { name: 'Work', path: '/work', permissions: null },
    { name: 'Work Verifier', path: '/workVerifier', permissions: null },
];
